/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    const formattedValues = values.map((value) => `${value}`)
    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  created_on: queryFiltersMappings.eq,
  event: queryFiltersMappings.eq,
  'expected_departure_on:gte': queryFiltersMappings.gte,
  'expected_departure_on:lte': queryFiltersMappings.lte,
  'load_weight:gte': queryFiltersMappings.gte,
  'load_weight:lte': queryFiltersMappings.lte,
  'load_volume:gte': queryFiltersMappings.gte,
  'load_volume:lte': queryFiltersMappings.lte,
  'start_address.id:in': queryFiltersMappings.in,
  'vehicle.id:in': queryFiltersMappings.in,
  'driver_user.id:in': queryFiltersMappings.in,
  'driver_user_2.id:in': queryFiltersMappings.in,
  'user_group.id:in': queryFiltersMappings.in,
}

export default filterMappings
